import * as React from 'react';
import { NavLink } from 'react-router-dom';

import Tag from 'antd/es/tag';

import { Region } from '@commonTuna/react/objects/Region';

interface Props {
	location: Region;
	tagClassName?: string;
	style?: any;
}

const RegionTag: React.FC<Props> = (props) => {
	const location = props.location;

	return (<>
		{location.path
			? <NavLink to={`/locations/${location.path}`}>
				<Tag color="blue" key={location.id} style={props.style} className={props.tagClassName}>
					{location.name}
				</Tag>
			</NavLink>
			: <Tag color="blue" key={location.id} style={props.style} className={props.tagClassName}>
				{location.name}
			</Tag>
		}
	</>);
};

export default RegionTag;
